import "./article.scss";
import { IArticleBultenResponseModel } from "../../core/models";
import ActionFooter from "../ActionFooter/ActionFooter";
import ArticlePdf from "../ArticlePdf/ArticlePdf";

export interface IArticleSecondaryProps {
  content: IArticleBultenResponseModel;
}

const ArticleBulten = ({ content }: IArticleSecondaryProps) => {
  const pushEventForShare = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Paylaş Butonu",
          eventSegment: { baslik: content?.bulten_title, tip: "Bülten" },
          actionType: "event",
        })
      );
    }
  };

  if (window && (window as any)["ReactNativeWebView"]) {
    (window as any)["ReactNativeWebView"].postMessage(
      JSON.stringify({
        message: "eventLogForCountly",
        eventName: "Haber Görütüleme",
        eventSegment: {
          baslik: content?.bulten_title,
          tarih: content?.bulten_date_f,
        },
        actionType: "event",
      })
    );
  }

  return (
    <>
      {content.bulten_pdf ? (
        <ArticlePdf
          content={{
            document_url: content.bulten_pdf,
            page_shareurl: content.page_shareurl,
          }}
        />
      ) : (
        <>
          <article className="article-secondary">
            <div className="article-secondary__text">
              <div className="article-secondary__head">
                <div className="article-secondary__head-bottom">
                  <span>{content.bulten_date_f}</span>
                  <span>{content.bulten_title}</span>
                </div>
              </div>

              {content.bulten_content && (
                <div
                  className="article-secondary__text-description borsaArticle lightTheme"
                  dangerouslySetInnerHTML={{ __html: content.bulten_content }}
                ></div>
              )}
            </div>
          </article>
          {content.page_shareurl && (
            <ActionFooter
              onHandleShare={pushEventForShare}
              content={{
                button_items: [
                  {
                    title: "Paylaş",
                    url: content.page_shareurl,
                  },
                ],
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default ArticleBulten;
